import React from "react";
import fibiPopUp from "../../../images/web/fibi-popup.jpeg";
import { useNavigate } from "react-router-dom";
import { WebPaths } from "../../../routes/data";
import { FaTimesCircle } from "react-icons/fa";
import { FaRocket } from "react-icons/fa6";

interface Props {
  isOpen: boolean;
  onClose: () => void;
}

const FiBiPopUp: React.FC<Props> = ({ isOpen, onClose }) => {
  const navigate = useNavigate();
  return (
    <div
      className={`${
        isOpen
          ? "fixed inset-0 z-10 bg-black/50 backdrop-blur-xs grid place-content-center"
          : "hidden"
      }`}
      onClick={onClose}
    >
      <div className="bg-white p-8 rounded-xl shadow-xl w-[85vw] sm:max-w-[500px] flex flex-col items-center relative">
        <div
          role="button"
          onClick={onClose}
          className="absolute p-3 text-red-400 duration-200 bg-white rounded-full cursor-pointer -top-5 -right-5 hover:text-red-500"
        >
          <FaTimesCircle className="w-5 h-5" />
        </div>
        <img
          src={fibiPopUp}
          alt="fibi pop up modal"
          className="transition-all duration-500 cursor-pointer hover:scale-110"
          onClick={() => {
            navigate(WebPaths.FiBiAi);
            onClose();
          }}
        />

        <div
          className="absolute -bottom-16 mt-4 text-center text-xl bg-[#0076e9] text-white rounded-xl px-6 py-3 cursor-pointer hover:bg-Blue01 hover:shadow-[0_0_20px_rgba(0,123,255,0.5)] duration-200 flex items-center gap-2 overflow-hidden group hover:scale-105"
          onClick={() => {
            navigate(WebPaths.FiBiAi);
            onClose();
          }}
          onMouseMove={(e) => {
            const rect = e.currentTarget.getBoundingClientRect();
            const x = ((e.clientX - rect.left) / rect.width) * 100;
            const y = ((e.clientY - rect.top) / rect.height) * 100;
            e.currentTarget.style.setProperty("--mouse-x", `${x}%`);
            e.currentTarget.style.setProperty("--mouse-y", `${y}%`);
          }}
          style={{
            background: "linear-gradient(135deg, #007bff, #0056b3)",
          }}
        >
          <div
            className="absolute inset-0 pointer-events-none opacity-0 group-hover:opacity-100"
            style={{
              background:
                "radial-gradient(circle at var(--mouse-x, 50%) var(--mouse-y, 50%), rgba(255, 255, 255, 0.4) 0%, transparent 70%)",
            }}
          ></div>
          <FaRocket className="w-5 h-5" />
          Get Started
        </div>
      </div>
    </div>
  );
};

export default FiBiPopUp;
